<template>
  <v-card>
    <v-form ref="form" :lazy-validation="true">
      <v-icon class="close" @click="close">$sl-close</v-icon>
      <v-card-title> {{profession.distanceEducationProviderObj}}
        <span class="display-1" v-if="profession.name">{{ profession.name }}</span>
        <span class="display-1" v-else>Skapa nytt yrke</span>
      </v-card-title>

      <v-card-text>
        <v-row>
          <v-col cols="12">
            <v-text-field
              outlined
              :rules="[rules.required]"
              v-model="profession.name"
              label="Yrke"
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-text-field
              outlined
              v-model="profession.shortname"
              label="Benämning"
            ></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-checkbox
              :false-value="false"
              :true-value="true"
              v-model="profession.isMachineProfession"
              label="Maskinyrke"
            ></v-checkbox>
          </v-col>
          <v-col cols="6">
            <v-checkbox
              :false-value="0"
              :true-value="true"
              v-model="profession.isApplicationProfession"
              label="Visas i anmälan"
            ></v-checkbox>
          </v-col>
        <v-col cols="12">
            <v-select
              outlined
              v-model="daysUntilOrderApprovalObj"
              :items="payTimeArray"
              :rules="[rules.required]"
              item-text="text"
              item-value="value"
              label="Betalningstid *"              
              return-object
            ></v-select>
          </v-col>
          <v-col cols="12">
            <v-text-field
              outlined
              type="number"
              v-model="profession.maxApprenticesForInstructor"
              label="Max antal lärlingar per handledare"
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-select
              outlined
              v-model="distanceEducationProviderObj"
              :items="distanceEducationProviders"
              :rules="[rules.required]"
              item-text="name"
              item-value="id"
              label="Utbildningsgivare *"
              return-object
            ></v-select>
          </v-col>
          <!-- <v-col cols="6">
                <v-icon>$sl-{{ profession.icon }}</v-icon>
          </v-col>-->
          <v-col cols="12">
            <v-text-field
              outlined
              :disabled="true"
              v-model="profession.newInstructionsAt"
              placeholder="Datum"
              label="Handledarinstruktioner uppdaterade"
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-text-field outlined v-model="profession.icon" label="Ikon"></v-text-field>
          </v-col>
          <v-col>
            <v-textarea
              outlined
              label="Beskrivning"
              :rules="[rules.required]"
              v-model="profession.description"
              rows="5"
            ></v-textarea>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions class="d-flex justify-end mx-2">
        <v-btn color="secondary" @click="close">
          <v-icon>$sl-cancel</v-icon>Avbryt
        </v-btn>
        <v-btn color="primary" class="icon" @click="save">
          <v-icon>$sl-check</v-icon>Spara
        </v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import API from "@/services/api.js";
import { RulesMixin } from "@/components/mixins";
import find from "lodash/find";
import findIndex from "lodash/findIndex";
// @group Common
// Styled AdminProfessionsDetail component
export default {
  name: "AdminProfessionsDetail",

  mixins: [RulesMixin],

  props: {
    //has profession
    profession: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    menu1: false,
    payTimeArray: [{text: '14 dagar', value: 14}, {text: '30 dagar', value: 30}, {text: '60 dagar', value: 60}],    
    distanceEducationProviders: [],
    distanceEducationProviderObj: {},
    daysUntilOrderApprovalObj: {}
  }),
  created() {
    this.getDistanceEducationProviders();
  },
  watch: {
    "profession.id": {
      handler: function () {
        this.init();
      },
      deep: true,      
    },
  },
  methods: {
    close() {
      // Fire close event
      // @arg The argument is boolean false to close the modal
      this.$emit("close");
    },
    init(){
      this.setSelectedDistanceEducationProvider();       
      
      if(this.profession && this.profession.daysUntilOrderApproval && this.profession.daysUntilOrderApproval>0){
        let found = find(this.payTimeArray, {
          value: this.profession.daysUntilOrderApproval,
        });
        
        if (found) {
          this.daysUntilOrderApprovalObj = found;
        }      
      }
      // else {
      //   this.daysUntilOrderApprovalObj={}
      // }
    },
    setSelectedDistanceEducationProvider() { 
      let dist = find(this.distanceEducationProviders, {
        id: this.profession.distanceEducationProviderId,
      });

      if (dist) {
        this.distanceEducationProviderObj = dist;
      }      
    },
    getDistanceEducationProviders() {
      API.listDistanceEducationProviders()
        .then((response) => {
          this.distanceEducationProviders = response.data;
          this.setSelectedDistanceEducationProvider();
        })
        .catch((error) => {
          console.log("There was an error:", error.response);
        });
    },
    /**
     * @vuese
     * Used to update Professions or create a new one
     * @arg the argument profession id
     */
    save() {
      //- Valid ?
      if (!this.$refs.form.validate()) {
        this.$events.fire("showError", "Formuläret är inte korrekt ifyllt.");
        return;
      }
      if (Number(this.distanceEducationProviderObj.id) > 0) {
        this.profession.distanceEducationProviderId = this.distanceEducationProviderObj.id;
      } else {
        this.$events.fire("showError", "Vänligen välj en distansutbildningsgivare.");
        return;
      }      

      if (Number(this.daysUntilOrderApprovalObj.value) > 0) {
        this.profession.daysUntilOrderApproval = this.daysUntilOrderApprovalObj.value;
      } else {
        this.$events.fire("showError", "Vänligen välj betalningstid.");
        return;
      }
      if (this.profession.id > 0) {
        //- Existing item
        API.updateProfessions(this.profession.id, { data: this.profession })
          .then((response) => {
            this.distanceEducationProviderObj = {};
            this.$events.fire("showInfo", "Sparad.");
            this.$emit("save");
          })
          .catch((error) => {
            this.$events.fire(
              "showError",
              "Ett fel uppstod (" +
                error.message +
                "), om detta händer igen v.v. kontakta BYN:s kansli."
            );
            console.log("There was an error:", error);
          });
      } else {
        //- New item

        API.createProfessions({ data: this.profession })
          .then((response) => {
            this.$events.fire("showInfo", "Skapad.");
            this.$emit("save");
          })
          .catch((error) => {
            this.$events.fire(
              "showError",
              "Ett fel uppstod (" +
                error.message +
                "), om detta händer igen v.v. kontakta BYN:s kansli."
            );
            console.log("There was an error:", error);
          });
      }
    },
  },
};
</script>
<style lang="scss">
.v-textarea.v-text-field--enclosed .v-text-field__slot textarea {
  line-height: 1.6;
}
</style>
